import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IdentityService } from 'src/app/core/identity.service';
import { FollowUpViewBase } from 'src/app/shared/models/followup-base-view.model';

@UntilDestroy()
@Component({
    selector: 'nova-recruiter-resources-base',
    template: '<div></div>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    styleUrls: []
})
export abstract class RecruiterResourcesBaseComponent implements OnInit {
    candidateId: number;

    recruiterId: number;

    followup: FollowUpViewBase;

    isDoneLoading = signal(false);

    constructor(
        private readonly route: ActivatedRoute,
        private readonly identityService: IdentityService
    ) {}

    ngOnInit(): void {
        this.recruiterId = this.identityService.current.contactId;

        this.route.params.pipe(untilDestroyed(this)).subscribe((params) => {
            this.candidateId = params.id;

            this.requestRecruiterFollowupForCandidate();
        });
    }

    public abstract requestRecruiterFollowupForCandidate(): void;
}
